export const TRACKS_URL = Object.freeze({
  path: '/tracks',
  view: {
    name: 'track.view',
    path: '/tracks/view/:id',
  },
  edit: {
    name: 'track.edit',
    path: '/tracks/edit/:id',
  },
  create: {
    name: 'track.create',
    path: '/tracks/create',
  },
  notfound: {
    name: 'track.notfound',
    path: '/tracks/notfound',
  },
  forbidden: {
    name: 'track.forbidden',
    path: '/tracks/forbidden',
  },
  denied: {
    name: 'track.denied',
    path: '/tracks/denied',
  },
});

export const TRACK_ERRORS = {
  404: 'TRACK_NOT_FOUND',
  403: 'FORBIDDEN',
  401: 'PERMISSION_DENIED',
};

export const TRACK_ACCESS_INFO = {
  0: 'public-track-access-info',
  1: 'department-track-access-info',
};
